var currentRequest = null;
var $searchfield = $('.autocomplete');
var matchFlag = 0;

function dynamic_height_remove() {
    $('.dynamic-height-section').css('height', 'auto');
}
function dynamic_height($results, $no_results) {
    var autoHeightResults = $results.height();
    var autoHeightnoResults = $no_results.height();
    var bannerHeight = $('.dynamic-height-section').height() - 30;
    var newHeight =
        (autoHeightResults ? autoHeightResults : autoHeightnoResults) +
        bannerHeight;
    $('.dynamic-height-section').height(newHeight);
}

const AutoCompleteV2Inner = {
    base_url: $('#base-url').attr('data-url'),
    clientLat: '',
    clientLong: '',
    handleResults(results, $input) {
        var $results = $input.next('.autocomplete-results');
        var $no_results = $input.next().next('.autocomplete-no-results');

        $no_results.removeClass('is-active');

        $results.empty();

        var is_small = $results.width() < 480 ? 'is-small' : '';
        var is_medium = $results.width() < 768 ? 'is-medium' : '';
        var exact_match = [];
        matchFlag = 0;
        var fetchArray = ['metro_areas', 'locations', 'windsor_properties'];
        if (results['exact_match'] && results['exact_match'].length > 0) {
            exact_match = results['exact_match'][0];
            if (exact_match['post_type'] == 'locations') {
                fetchArray = ['locations'];
            } else if (exact_match['post_type'] == 'windsor_properties') {
                fetchArray = ['windsor_properties', 'locations'];
            } else if (exact_match['post_type'] == 'metro_areas') {
                fetchArray = ['metro_areas', 'locations'];
            }
            matchFlag = 1;
            $('.search-link').val(exact_match.link);
            $('.cta-search').addClass('enabled');
            $('.icon-search img').attr(
                'src',
                $('.icon-search img').data('enabled-img')
            );
        }
        var match = '';

        fetchArray.forEach((element) => {
            var head = `<li class="group autocomplete-results__item inner-page capitalize ${is_small} head-text mt-2 pt-6 pl-2">
                        <span class="flex flex-col items-start md:flex md:flex-row md:items-center md:gap-8">
                            <span class="text-brand-primary group-hover:text-brand-primary ">`;
            if (element == 'windsor_properties') {
                head += `COMMUNITIES`;
            } else if (element == 'locations') {
                head += `CITIES`;
            } else if (element == 'metro_areas') {
                head += `METRO AREAS`;
            }
            head += `</span>
                        </span>
                </li>`;
            if (
                (results[element] && results[element].length > 0) ||
                (exact_match &&
                    exact_match.hasOwnProperty('post_type') &&
                    exact_match['post_type'] == element)
            ) {
                $results.append(head);
            }

            if (
                exact_match &&
                exact_match.hasOwnProperty('post_type') &&
                exact_match['post_type'] == element
            ) {
                match += `<li class="group autocomplete-results__item ${is_small} inner-page capitalize" data-link="${exact_match.link}" data-name="${exact_match.title}">
                    <a href="${exact_match.link}" class="autocomplete-results__link match-value" >
                        <span class="flex flex-col items-start md:flex md:flex-row md:items-center md:gap-8">
                            <span class="result-part1 text-secondary-blue md:text-lg">
                                ${exact_match.title}
                            </span>
                            <span class="result-part2 md:text-[18px] text-neutral-dark-gray font-normal">`;
                if (element == 'locations' || element == 'metro_areas') {
                    match += `${
                        exact_match.num_properties == 1
                            ? `${exact_match.num_properties} Community`
                            : `${exact_match.num_properties} Communities`
                    }`;
                } else if (element == 'windsor_properties') {
                    match += `${exact_match.location}`;
                }
                match += `</span>
                        </span>
                    </a>
                </li>`;
                $results.append(match);
            }
            if (results[element] && results[element].length > 0) {
                $.each(results[element], function (i, loc) {
                    var data = `
                        <li class="group autocomplete-results__item ${is_small} inner-page capitalize" data-link="${loc.link}" data-name="${loc.title}">
                            <a href="${loc.link}" class="autocomplete-results__link">
                                <span class="flex flex-col items-start md:flex md:flex-row md:items-center md:gap-8">
                                    <span class="result-part1 text-secondary-blue md:text-lg">
                                        ${loc.title}
                                    </span>
                                    <span class="result-part2 md:text-[18px] text-neutral-dark-gray font-normal">`;
                    if (element == 'locations' || element == 'metro_areas') {
                        data += `${
                            loc.num_properties == 1
                                ? `${loc.num_properties} Community`
                                : `${loc.num_properties} Communities`
                        }`;
                    } else if (element == 'windsor_properties') {
                        data += `${loc.location}`;
                    }
                    `</span>
                                </span>
                            </a>
                        </li>
                    `;
                    $results.append(data);
                });
            }
        });
        if (matchFlag == 1) {
            $('.cta-search').addClass('enabled');
            $('.icon-search').addClass('enabled');
            $('.icon-search img').attr(
                'src',
                $('.icon-search img').data('enabled-img')
            );
        } else {
            $('.cta-search').removeClass('enabled');
            $('.icon-search').removeClass('enabled');
            $('.icon-search img').attr(
                'src',
                $('.icon-search img').data('disabled-img')
            );
        }
        $results.addClass('is-active');
        $input.closest('.autocomplete').addClass('active');
    },
    handleNoResults($input, suggestions = []) {
        var $results = $input.next('.autocomplete-results');
        var $no_results = $input.next().next('.autocomplete-no-results');
        $results.empty();
        $results.removeClass('is-active');
        if (suggestions && Object.keys(suggestions).length > 0) {
            $no_results.html(
                "<p class='text-lg mb-5 no-results-text pt-4 normal-case'> We can't find \"" +
                    $input.val() +
                    "\"</p><span class='md:text-base normal-case font-nunito-sans'>Did you mean: <span class='no-results-suggestions'>\"<a href='javascript:void(0);' class='suggestion-update underline font-playfair'>" +
                    suggestions['title'] +
                    '</a>"</span></span>'
            );
        } else {
            $no_results.html(
                "<p class='text-lg mb-5 no-results-text pt-4 normal-case'>Sorry we haven't settled there yet.</p><a href='/find-apartments/' class='text-base no-results-link py-1 capitalize'>View All Windsor Locations<span class='ml-2 arw-right inline-block w-[6px] h-[12px]'> </span></a>"
            );
        }
        $no_results.addClass('is-active');
        $input.closest('.autocomplete').addClass('active');
    },
    clearResults($input) {
        var $results = $input.next('.autocomplete-results');
        var $no_results = $input.next().next('.autocomplete-no-results');

        $results.empty().removeClass('is-active');
        $no_results.removeClass('is-active');
        $input.closest('.autocomplete').removeClass('active');
    },
    doSearch($input) {
        $(document).off('keydown', AutoCompleteV2Inner.handleUpDown);

        var searchVal = $input.val();
        if (
            $.inArray(searchVal.toLowerCase(), [
                'washington dc',
                'dc',
                'd.c',
                'd.c.',
                'dc.',
                'washington dc.',
                'washington d.c',
            ]) !== -1
        ) {
            searchVal = 'Washington D.C.';
        }
        if (searchVal.length > 2) {
            AutoCompleteV2Inner.clearResults($input);
            AutoCompleteV2Inner.showLoader($input);
            currentRequest = $.ajax({
                url: AutoCompleteV2Inner.base_url + '/wp-admin/admin-ajax.php',
                method: 'POST',
                data: {
                    action: 'autocomplete_location_property_search_v2',
                    s: searchVal,
                    lat: AutoCompleteV2Inner.clientLat,
                    long: AutoCompleteV2Inner.clientLong,
                    innerFlag: 1,
                },
                beforeSend: function () {
                    if (currentRequest != null) {
                        currentRequest.abort();
                    }
                },
                success: function (data) {
                    AutoCompleteV2Inner.hideLoader($input);
                    if (data) {
                        var results = JSON.parse(data);
                        if (
                            results &&
                            ((results.windsor_properties &&
                                results.windsor_properties.length > 0) ||
                                (results.locations &&
                                    results.locations.length > 0) ||
                                (results.exact_match &&
                                    results.exact_match.length > 0) ||
                                (results.metro_areas &&
                                    results.metro_areas.length > 0))
                        ) {
                            AutoCompleteV2Inner.handleResults(results, $input);
                        } else {
                            $('.cta-search').removeClass('enabled');
                            $('.icon-search').removeClass('enabled');
                            $('.icon-search img').attr(
                                'src',
                                $('.icon-search img').data('disabled-img')
                            );
                            AutoCompleteV2Inner.clearResults($input);
                            if ($input.val().length > 2) {
                                var suggestions = [];
                                if (
                                    results.suggestions &&
                                    Object.keys(results.suggestions).length > 0
                                ) {
                                    suggestions = results.suggestions;
                                }
                                AutoCompleteV2Inner.handleNoResults(
                                    $input,
                                    suggestions
                                );
                            }
                        }
                    }
                },
            });
        } else {
            if (currentRequest != null) {
                currentRequest.abort();
            }
            $('.cta-search').removeClass('enabled');
            $('.icon-search img').attr(
                'src',
                $('.icon-search img').data('disabled-img')
            );
            AutoCompleteV2Inner.clearResults($input);
            AutoCompleteV2Inner.hideLoader($input);
        }
    },
    handleUpDown(e) {
        var $focused_li = $('.autocomplete-results a:focus').parent();
        // if in input, make the down press select the first option
        switch (e.keyCode) {
            case 38: // up
                if ($focused_li.length > 0 && $focused_li.index() > 0) {
                    // if in a result, select the previous result
                    $focused_li.prev().find('a').focus();
                    return false;
                }
                break;
            case 40: // down
                if ($('.autocomplete-input-v2-inner:focus').length > 0) {
                    // if in the autocomplete, select the first result
                    $('.autocomplete-input-v2-inner:focus')
                        .next('.autocomplete-results')
                        .find('li')
                        .eq(0)
                        .find('a')
                        .trigger('focus');
                    return false;
                }

                if ($focused_li.length > 0 && $focused_li.next().length > 0) {
                    // if in a result, select the next result
                    $focused_li.next().find('a').focus();
                    $focused_li.next()[0].scrollIntoView({
                        behavior: 'smooth',
                        block: 'nearest',
                        inline: 'start',
                    });

                    return false;
                }
                break;
        }
    },
    showLoader($input) {
        $input.parent().find('.autocomplete-loading').addClass('is-loading');
    },
    hideLoader($input) {
        $input.parent().find('.autocomplete-loading').removeClass('is-loading');
    },
    init() {
        $('.autocomplete-input-v2-inner').each(function () {
            var $ac = $(this);
            $(this).on('keyup', function (e) {
                if (e.which != 13) {
                    AutoCompleteV2Inner.doSearch($ac);
                } else {
                    if (matchFlag == 1) {
                        window.location.href = $('.match-value').attr('href');
                    }
                }
            });
        });

        $('.autocomplete-input-v2-inner').on('click', function () {
            AutoCompleteV2Inner.doSearch($(this));
        });

        // remove results on click outside
        $(document).on('click', function (event) {
            var $target = $(event.target);
            if (
                !$target.closest('.autocomplete').length &&
                $('.autocomplete').is(':visible')
            ) {
                AutoCompleteV2Inner.clearResults(
                    $('.autocomplete-input-v2-inner')
                );
                // console.log("Click");
            }
        });

        $(document).on('click focusin', function (event) {
            setTimeout(() => {
                const $inputField = $('.autocomplete-input-v2-inner');
                const $resultsList = $('.autocomplete-results');
    
                // Check if the focus or click happened outside the input field and the results list
                if (
                    !$inputField.is(event.target) && // The target is not the input field
                    !$resultsList.is(event.target) && // The target is not the results list
                    $resultsList.has(event.target).length === 0 && // The target is not a child of the results list
                    $resultsList.hasClass('is-active')
                ) {
                    //   clearResults();
                    console.log('focus out');
                    AutoCompleteV2Inner.clearResults($inputField);
                }
            }, 250);
        });

        $('.autocomplete-no-results').on(
            'click',
            '.suggestion-update',
            function (event) {
                var autocompleteContainer = $(this).closest(
                    '.autocomplete-no-results'
                );
                if ($(autocompleteContainer).hasClass('inner-auto')) {
                    event.preventDefault();
                    var suggestion = $(this).text();
                    var $input = autocompleteContainer.prev().prev();
                    $input.val(suggestion);
                    $input.focus();
                    $input.trigger('keyup');
                }
            }
        );

        $('.autocomplete-results').on(
            'click',
            '.autocomplete-results__item',
            function (event) {
                if ($(this).hasClass('inner-page')) {
                    event.preventDefault();
                    var suggestion = $(this).data('name');
                    var link = $(this).data('link');
                    $('.autocomplete-input-v2-inner').val(suggestion);
                    $('.search-link').val(link);
                    $('.cta-search').addClass('enabled');
                    $('.icon-search img').attr(
                        'src',
                        $('.icon-search img').data('enabled-img')
                    );
                    $('.autocomplete-input-v2-inner').focus();
                    var $results = $(this).parent();
                    $results.empty();
                    $results.removeClass('is-active');
                }
            }
        );

        $('.advanced-search-btn').on('click', function (e) {
            e.preventDefault();
            if ($(this).hasClass('enabled')) {
                var searchURL = $('.search-link').val();
                var params = new URLSearchParams(window.location.search);

                var filterParams = [
                    'price',
                    'date',
                    'beds',
                    'community',
                    'apartment',
                    'commute',
                    'lng',
                    'lat',
                    'radius',
                    'baths',
                    'order',
                ];

                filterParams.forEach(function (param) {
                    var value = params.get(param);
                    if (value !== null) {
                        searchURL = appendQueryParam(searchURL, param, value);
                    }
                });
                window.location.href = searchURL;
            }
        });

        // Function to append a query parameter to a URL
        function appendQueryParam(url, key, value) {
            var separator = url.indexOf('?') === -1 ? '?' : '&';
            return (
                url +
                separator +
                encodeURIComponent(key) +
                '=' +
                encodeURIComponent(value)
            );
        }
    },
};

export default AutoCompleteV2Inner;
